import PropTypes from 'prop-types';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

import TablerIcon from '../tabler-icon';

import 'react-datepicker/dist/react-datepicker.css';
import '../DateField/index.scss';
import './index.scss';

const MonthYearPicker = ({ label, onChange, initialDate, inputProps, ...props }) => {
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [isDatepickerOpen, setIsDatepickerOpen] = useState(false);

  const toggleDatePicker = () => setIsDatepickerOpen(prev => !prev);

  const formatDateForRoEForm = date => {
    if (!date) return null;
    const year = date.getFullYear();
    // eslint-disable-next-line prefer-template
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const dateStr = ('0' + date.getDate()).slice(-2);
    return {
      year: year.toString(),
      month: month.toString(),
      day: dateStr.toString(),
    };
  };

  const onDatePick = pickedDate => {
    setSelectedDate(pickedDate);
    onChange(formatDateForRoEForm(pickedDate));
    toggleDatePicker();
  };

  return (
    <>
      <div className="date-picker-input">
        <label className="date-picker-label">{label}</label>
        <div className="date-picker-container">
          <TablerIcon name="calendar" color="#344054" size={24} />
          <DatePicker
            onFocus={e => {
              e.target.readOnly = true;
              e.target.blur();
            }}
            {...props}
            selected={selectedDate}
            shouldCloseOnSelect
            onChange={onDatePick}
            onClickOutside={toggleDatePicker}
            onInputClick={toggleDatePicker}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            open={isDatepickerOpen}
            placeholderText="Pick a date"
            popperPlacement="bottom-start"
            showPopperArrow={false}
            className="datepicker_input"
            wrapperClassName="datepicker_wrapper"
            showDisabledMonthNavigation
            monthClassName={() => 'datepicker_month'}
            renderCustomHeader={({ date, decreaseYear, increaseYear }) => {
              return (
                <div className="month-picker-header-container">
                  <TablerIcon
                    name="chevron_left"
                    size={24}
                    color="#008ECF"
                    onClick={decreaseYear}
                    className="chevron-icon"
                    aria-label="Previous Year"
                  />
                  <h5>{date.getFullYear()}</h5>
                  <TablerIcon
                    name="chevron_right"
                    size={24}
                    color="#008ECF"
                    onClick={increaseYear}
                    className="chevron-icon"
                    aria-label="Next Year"
                  />
                </div>
              );
            }}
            customInput={<input data-testid={inputProps} />}
          />
          <TablerIcon
            className={`chevron-icon ${isDatepickerOpen ? 'open' : ''}`}
            name="chevron-down"
            size={24}
            color="#344054"
            onClick={toggleDatePicker}
          />
        </div>
      </div>
    </>
  );
};

MonthYearPicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialDate: PropTypes.instanceOf(Date),
  label: PropTypes.string.isRequired,
  inputProps: PropTypes.string,
};

MonthYearPicker.defaultProps = {};

export default MonthYearPicker;
